module.exports = __webpack_public_path__ + "media/images/icon_name01_11-20-430904d778d46e8c7fddccf0485f8019.png";